import { render, staticRenderFns } from "./auth_lg.vue?vue&type=template&id=63c5298a&scoped=true&"
import script from "./auth_lg.vue?vue&type=script&lang=js&"
export * from "./auth_lg.vue?vue&type=script&lang=js&"
import style0 from "./auth_lg.vue?vue&type=style&index=0&id=63c5298a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c5298a",
  null
  
)

export default component.exports